import React from 'react';
import { useSelector } from 'react-redux';
import { getGameTabEnabled, getSelected, viewSlice } from './features/view/viewSlice';
import { getRoomTabState } from './features/room/roomSlice';
import classNames from "classnames";
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { getInited } from './features/init/initSlice';

import './Tabs.css';

export const Tabs = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const tab = useSelector(getSelected);
  const roomTabState = useSelector(getRoomTabState);
  const gameTabEnabled = useSelector(getGameTabEnabled);
  const inited = useSelector(getInited);

  const tabs = (() => {
    if (inited) {
      const mainTabCls = classNames({
        'tab': true,
        'selected': 'main' === tab,
      });

      const roomTabCls = classNames({
        'tab': true,
        'selected': 'room' === tab,
        'disabled': roomTabState === 0,
      });

      const gameTabCls = classNames({
        'tab': true,
        'selected': 'game' === tab,
        'disabled': !gameTabEnabled,
      });
    
      const onRoomTabClick = roomTabState !== 0
        ? e => dispatch(viewSlice.actions.setSelected({tab: 'room'}))
        : null;

      const onGameTabClick = gameTabEnabled
        ? e => dispatch(viewSlice.actions.setSelected({tab: 'game'}))
        : null;
      
      return (
        <>
          <div className={mainTabCls} onClick={e => dispatch(viewSlice.actions.setSelected({tab: 'main'}))}>{t('HOME')}</div>
          <div className="spacing"></div>
          <div className={roomTabCls} onClick={onRoomTabClick}>{t('GAMEROOM')}</div>
          <div className="spacing"></div>
          <div className={gameTabCls} onClick={onGameTabClick}>{t('MY_GAME')}</div>
        </>
      );
    }

    const loadingTabCls = classNames({
      'tab': true,
      'selected': true,
    });
    return (
      <div className={loadingTabCls}>...</div>
    );
  })();

  return (
    <div className="tabs">
      <div className="spacing"></div>
      {tabs}
      <div className="spacing"></div>
    </div>
  );
}
